// state.landlord.bookingConfirmationData.bookingData
export default {
  bookingConfirmationData: (state) => state.bookingConfirmationData,
  bookingConfirmationError: (state) => state.bookingConfirmationError,
};
